import {Input} from "antd";
import {forwardRef} from "react";

const InputField = forwardRef(({ name, onChange, onBlur, label, value, defaultValue, errors, placeholder, className, ...props }, ref) => {
	if(label && typeof placeholder == 'undefined') placeholder = label;
	//if(typeof value == 'undefined') value = defaultValue;

	return (
		<div className="form-group">
			{label && <label htmlFor={name}>{label}</label>}
			<Input
				name={name}
		        value={value}
		        onChange={onChange}
		        onBlur={onBlur}
				placeholder={placeholder}
				defaultValue={defaultValue}
		        {...props}
		        className={((errors && errors[name]) && 'error') + " form-control " + className}
				ref={ref}
			/>
			{errors && errors[name]?.message && (<p className="error-message">{errors[name]?.message}</p>)}
		</div>
	)
});

export default InputField;